export default __webpack_public_path__ + "static/media/Gujarati Village Level Committees roles.6ae4404d.pdf";